import client from 'lib/api/client';

export const getDeviceList = ({
  addDeviceListPage,
  deviceListPage,
  addDeviceListSearch,
  deviceListSearch,
}) =>
  client.get(
    `/device?deviceListPage=${deviceListPage}&addDeviceListPage=${addDeviceListPage}&deviceListPageSearch=${deviceListSearch}&addDeviceListSearch=${addDeviceListSearch}&limit=5`,
  );

export const getDevice = ({ id }) => client.get(`/device/store/${id}`);

export const getMacList = ({ storeId, deviceType, search }) =>
  client.get(
    `/device/mac?storeId=${storeId}&deviceType=${deviceType}&search=${search}`,
  );

export const createDevice = ({
  id,
  device: { spaceId, deviceId, name, deviceType, masterId },
}) =>
  client.post(`/device/store/${id}`, {
    device: {
      spaceId,
      id: deviceId,
      name,
      deviceType,
      masterId,
    },
  });

export const deleteDevice = ({ id, deviceId }) =>
  client.post(
    `/device/store/${id}`,
    { deviceId },
    {
      headers: {
        'X-Method-Override': 'DELETE',
      },
    },
  );
